import { render, staticRenderFns } from "./DefaultCreateForm.vue?vue&type=template&id=3d0ff73e&"
import script from "./DefaultCreateForm.vue?vue&type=script&lang=js&"
export * from "./DefaultCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports